export enum ToNominate {
  mandatory = 'mandatory',
  indicative = 'indicative',
  off = 'off',
}
